import DomainForm from "@/components/funnel/DomainForm";
import { Reveal } from "@/components/anim/Reveal";
import { HE } from "@/lib/i18n";
import { t } from "@/lib/strings";

export const FinalCTA = ({ onAnalyze, loading }) => (
  <section className="py-20 md:py-28 bg-obsidian text-white av-grid-bg">
    <div className="av-container text-center max-w-3xl mx-auto">
      <Reveal>
        <span className="av-label text-conversion">{t("final.label")}</span>
        {HE ? (
          <>
            <h2 className="font-display text-4xl sm:text-6xl leading-[0.98] mt-4">
              שימצאו אתכם. שימליצו עליכם.<br className="hidden sm:block" /> שיגיעו לקוחות.
            </h2>
            <p className="mt-6 text-lg text-neutral-300">
              <strong className="text-white">אתר אחד. קליק אחד.</strong> דוח נראות ה-AI המלא + תוכנית פעולה בוואטסאפ — <strong className="text-white">תוך שניות</strong>.
            </p>
          </>
        ) : (
          <>
            <h2 className="font-display text-4xl sm:text-6xl leading-[0.98] mt-4">
              Get found. Get recommended.<br className="hidden sm:block" /> Get customers.
            </h2>
            <p className="mt-6 text-lg text-neutral-300">
              <strong className="text-white">One domain. One click.</strong> Your full AI visibility report + action plan on WhatsApp <strong className="text-white">in seconds</strong>.
            </p>
          </>
        )}
      </Reveal>
      <Reveal delay={0.15} className="mt-10 max-w-xl mx-auto">
        <DomainForm
          onAnalyze={onAnalyze}
          loading={loading}
          testid="final-domain-form"
          inputTestId="final-domain-input"
          submitTestId="final-analyze-submit"
        />
      </Reveal>
      <p className="mt-4 font-data text-xs uppercase tracking-widest text-neutral-500">
        {t("final.micro")}
      </p>
    </div>
  </section>
);

export default FinalCTA;
